import React from "react";
const PrivacyNotice: React.FC = () => {
  return (
    <div style={{ textIndent: "1em" }}>
      <section>
        <div style={{ width: "99%", textAlign: "right" }}>
          制定日　2024年12月16日
          <br /> 最終改正日　2024年12月16日
        </div>

        <p>
          ウィソフト株式会社（以下、「当社」という。）は、当社にとって個人情報及び特定個人情報の保護が重大な責務であると認識しております。
          そこで個人情報保護理念と自ら定めた行動規範に基づき、以下に示す方針を具現化するための個人情報保護マネジメントシステムを構築し、
          最新のＩＴ技術の動向、社会的要請の変化、経営環境の変動等を常に認識しながら、その継続的改善に、全社を挙げて取り組むことをここに宣言致します。
        </p>
      </section>

      <section>
        <ol>
          <li>
            当社は、事業の内容及び規模を考慮した適切な個人情報の取得・利用及び提供を行い、
            特定された利用目的の達成に必要な範囲を超えた個人情報の取扱いを行ないません。また、そのための措置を講じます。
          </li>
          <li>
            当社は個人情報の取扱いに関する法令、国が定める指針その他の規範を遵守致します。
          </li>
          <li>
            当社は個人情報の漏えい、滅失、き損などのリスクに対して、合理的な安全対策を講じて防止する規程、体制を構築し、
            継続的に向上させていきます。また、万一の際には速やかに是正措置を講じます。
          </li>
          <li>
            当社は個人情報取扱いに関する苦情及び相談に対しては、迅速かつ誠実に対応致します。
          </li>
          <li>
            個人情報保護マネジメントシステムは、当社を取り巻く環境の変化と実情を踏まえ、
            適時・適切に見直して継続的に改善をはかっていきます。
          </li>
        </ol>
        <p style={{ width: "99%", textAlign: "right" }}>
          ウィソフト株式会社　代表取締役　崔　国棟
        </p>
      </section>

      <section
        style={{
          border: "1px solid ",
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <div style={{ textAlign: "left", textIndent: "0" }}>
          <h3>
            【個人情報保護方針に関するお問い合わせ先 兼
            個人情報に関する苦情・相談窓口】
          </h3>
          〒210-0022　神奈川県川崎市川崎区池田2丁目6番7号
          <br />
          ウィソフト株式会社　個人情報に関するお問い合わせ窓口
          <br />
          電話番号：044-280-6828
        </div>
      </section>

      <section>
        <h2>個人情報の取扱いについて</h2>
        <h3>個人情報の利用目的</h3>
        <ul>
          <li>
            <strong>(1) お客様の個人情報</strong>
            <br />
            当社のソフトウェア開発業務、人材派遣業務、教育業務、販売業務におけるサービスの提供、
            お客様へのご連絡、関連するアフターサービス、新商品や新たなサービスのご案内などに利用します。
          </li>
          <li>
            <strong>(2) お問い合わせ、資料請求をいただいた方の個人情報</strong>
            <br />
            お問い合わせにお答えするためや、ご要望いただいた資料の送付などに利用します。
          </li>
          <li>
            <strong>(3) 当社の株主様の個人情報</strong>
            <br />
            連絡、各種情報等の提供および株主管理及び関連・付帯する業務に利用します。
          </li>
          <li>
            <strong>(4) 採用応募者の個人情報</strong>
            <br />
            採用選考及びそれに伴う連絡などに利用します。
          </li>
          <li>
            <strong>(5) 当社の従業者情報</strong>
            <br />
            人事労務管理、業務管理、福利厚生、健康管理、セキュリティ管理などに利用します。
          </li>
          <li>
            <strong>(6) ご提供いただいた個人番号情報</strong>
            <br />
            法律で特定された「社会保険手続き」、「税務処理」などに利用します。
          </li>
        </ul>
      </section>

      <section>
        <h2>保有個人データ及び第三者提供記録に関する事項の周知について</h2>
        <ol>
          <li>
            <strong>当社の名称及び住所、代表者の氏名</strong>
            <br />
            名称：ウィソフト株式会社
            <br />
            住所：〒210-0022　神奈川県川崎市川崎区池田2丁目6番7号
            <br />
            代表者：崔　国棟
          </li>
          <li>
            <strong>個人情報保護管理者</strong>
            <br />
            張　静
            <br />
            連絡先：044-280-6828
          </li>
          <li>
            <strong>保有個人データの利用目的</strong>
            <br />
            各項目の内容は個人情報の利用目的と同様です。
          </li>
          <li>
            <strong>保有個人データ取扱いに関する苦情の申し出先</strong>
            <br />
            <div style={{ textIndent: "0" }}>
              保有個人データに関するお問合せにつきましては、下記窓口で受付けております。
              <br />
              〒210-0022　神奈川県川崎市川崎区池田2丁目6番7号
              <br />
              ウィソフト株式会社　個人情報に関するお問い合わせ窓口
              <br />
              連絡先：044-280-6828
            </div>
          </li>
          <li>
            <strong>当社の加入する認定個人情報保護団体について</strong>
            <br />
            当社の加入する認定個人情報保護団体はありません。
          </li>
          <li>
            <strong>開示等の手続きについて</strong>
            <br />
            開示等のご請求については、個人情報に関するお問い合わせ窓口までご連絡をお願いします。
          </li>
          <li>
            <strong>保有個人データ等の安全管理のために講じた措置</strong>
            <br />
            <div style={{ textIndent: "0" }}>
              <p>
                当社では、個人情報、特定個人情報の取扱いに関する規程、及び安全対策に関する規程を定め以下の措置を講じております。
              </p>
              <strong>(1) 基本方針の策定</strong>
              <p>
                ・個人情報の取扱いに関して方針を定め、個人情報保護方針として、社内に周知徹底するとともに、一般の方も入手できるようにウェブページで公開しています。
              </p>
              <strong>(2)個人データの取扱いに係る規律の整備</strong>
              <p>
                ・取得、利用、保存、提供、削除・廃棄等の段階ごとに、取扱方法、責任者
                <br />
                ・担当者及びその任務等について個人情報の取扱い手順を定め、規程文書としてまとめ、社内に周知しております。
              </p>
              <strong>(3)組織的安全管理措置</strong>
              <p>
                ・個人情報の取扱状況について、定期的に自己点検を実施するとともに、他部署や外部の者による公平な立場からの内部監査を定期的に実施しています。
                <br />・ 各個人情報を取扱う従業者を制限しています。
              </p>
              <strong>(4)人的安全管理措置</strong>
              <p>
                ・個人情報の取扱いに関する留意事項について、従業者に定期的な研修を実施しております。
                <br />・ 従業者から、秘密保持に関する誓約を得ています。
              </p>
              <strong>(5)物理的安全管理措置</strong>
              <p>
                ・取扱い担当者以外の従業者や他の権限を有しない者による個人情報の間覧を防止するため、取り扱う区域を限定しています。
                <br />
                ・個人情報を取扱う区域において、従業者の入退出管理を行っております。
                <br />
                ・個人情報は、施錠できるキャビネットやアクセス制限を行っているサーバに保管しています。
              </p>
              <strong>(6)技術的安全管理措置</strong>
              <p>
                ・サーバなどへの外部からの不正アクセスを防ぐために、ファイアウォールなどを導入しています。また、コンピューターウイルスなどの不正ソフトウェアへの対策を行っています。
                <br />
                ・個人情報の移送時は、以下の対策をとっております。
                <br />
                ‐媒体の移送時には、配送記録が残る方法を利用するか、直接手渡しするようにしています。
                <br />
                ‐電子データの通信には、暗号化するなどの漏洩対策を行っています。
              </p>
              <strong>(7)外的環境の把握</strong>
              <p>
                当社が外国において個人データを取り扱う場合には、その外的環境を分析・把握し、該当国に適用される法令等を把握したうえで、必要な安全管理措置を講じるものとします。
              </p>
            </div>
          </li>
        </ol>
      </section>
    </div>
  );
};

export default PrivacyNotice;
